module.exports = __webpack_public_path__ + "img/small-sku-icon.734a0ab.png";